import { action, makeObservable, observable, flow, toJS } from "mobx";
import { API } from "aws-amplify";
import { 
  getAgent, putAgent
} from "../../graphql/queries";
import { getAgentList } from "../../services/agents";

import ViewAgentStore from "./pages/ViewAgentStore";
import NewAgentStore from "./pages/NewAgentStore";

class AgentStore {
  isError = false;
  isLoading = false;
  isDuplicating = false;
  loadingConcierge = false;
  conciergeAgent = null;
  agents = [];
  selectedAgent = undefined;
  account = '';

  viewAgentStore = new ViewAgentStore();
  newAgentStore = new NewAgentStore();


  constructor() {
    makeObservable(this, {
      isError: observable,
      isLoading: observable,
      isDuplicating: observable,
      agents: observable,
      selectedAgent: observable,
      account: observable,
      viewAgentStore: observable,
      newAgentStore: observable,
      loadingConcierge: observable,
      conciergeAgent: observable,
      onChangeAccount: action,
      onSelectedAgentById: action,
      onSelectedAgent: action,
      fetchGetAgent: flow,
      duplicateAgent: flow,
      fetchConciergeAgent: flow,
      getAgentById: flow
    });
  }

  onChangeAccount = (value) => {
    this.account = value;
    this.newAgentStore.onChangeAccount(value);
    this.fetchGetAgent();
  }

  onSelectedAgentById = (value) => {
    const agent = this.agents.find(agent => agent.id === value);
    this.selectedAgent = {original: agent};
  }

  onSelectedAgent = (value) => {
    this.selectedAgent = value;
  }

  *fetchGetAgent() {
    try {
        this.isLoading = true;
        this.isError = false;
        
        // Use new HTTP endpoint to get current agent list
        const response = yield getAgentList();
        const agents = response.data?.agents || [];
        
        // Map the new agent structure to match expected format
        this.agents = agents.map(agent => ({
            ...agent,
            id: agent.uuid, // Add id field for backward compatibility
            created_by: agent.created_by || agent.creator || '',
            photo_url: agent.metadata?.imageUrl || agent.image || '',
            conversation_starters: agent.starters || []
        }));
    } catch (error) {
        console.error('Error fetching agents:', error);
        this.isError = true;
        this.agents = [];
    } finally {
        this.isLoading = false;
    }
  }

  *getAgentById(customer_id, agent_id) {
    try {
        this.isLoading = true;
        // GraphQL removed - commented out
        // const response = yield API.graphql({
        //     query: getAgent,
        //     variables: {
        //         input: {
        //         customer_id,
        //         id: agent_id
        //         },
        //     },
        //     authMode: 'AMAZON_COGNITO_USER_POOLS'
        // });
        const response = { data: { getAgent: { body: JSON.stringify({}) } } };
        const data = JSON.parse(response.data?.getAgent?.body);
      return data;
    } catch (error) {
        this.isError = true;
    } finally {
        this.isLoading = false;
    }
  }

  *duplicateAgent() {
    this.isDuplicating = true;
    const { original } = this.selectedAgent
    try {
      const input = {
        channels: original.channels,
        customer_id: original.customer_id,
        human_instructions: original.human_instructions,
        knowledge_base: JSON.parse(JSON.stringify(original.knowledge_base)),
        name: `Copy of ${original.name} `,
        prompt: original.prompt,
        id: "",
        job_title: original.job_title,
        persona: JSON.stringify(original.persona),
        tone: toJS(original.tone),
        extended_answer: original.extended_answer,
        scope: original.scope,
        actions: original.actions,
        add_to_concierge: false,
        use_prompter: false,
        conversation_starters: original.conversation_starters,
        domain: original.domain,
        photo_url: original.photo_file_name,
        signature: JSON.stringify(original.signature),
      };

      // GraphQL removed - commented out
      // yield API.graphql({
      //   query: putAgent,
      //   variables: { input: input },
      //   authMode: 'AMAZON_COGNITO_USER_POOLS'
      // });

      // yield this.fetchGetAgent()

    } catch (err) {
      this.isError = true;
    } finally {
      this.isDuplicating = false;
    }
  }

  *fetchConciergeAgent(customer){
    try {
      this.loadingConcierge = true;
      // GraphQL removed - commented out
      // const response = yield API.graphql({
      //   query: getAgent,
      //   variables: {input: {customer_id: customer, domain: "concierge" }},
      //   authMode: 'AMAZON_COGNITO_USER_POOLS'
      // });
      // const agents = JSON.parse(response.data.getAgent.body).filter(agent => agent.provider === 'openai');
      // this.conciergeAgent = agents[0];
    } catch (error) {
      console.error("Error getting Agents", error);
      console.log('Error fetching agents');
    } finally {
      this.loadingConcierg = false;
    }
  };
}

export default AgentStore;